import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { IonTabs } from '@ionic/angular';
import { ApiService } from 'src/app/providers/apiService/api.service';

@Component({
  selector: 'app-tabs',
  templateUrl: './tabs.page.html',
  styleUrls: ['./tabs.page.scss'],
})
export class TabsPage implements OnInit {
  @ViewChild('tabs', { static: false }) tabs: IonTabs;
  unreadCount: any;
  selectedTab='Billing';
  constructor( private apiService: ApiService,
    public router: Router,) { }

  ngOnInit() {
    this.getnotificationCount();
  }

  getnotificationCount() {

    this.apiService
      .post('user/get-unread-notification-count', {})
      .subscribe(
        (res) => {
          if (res.error === false) {
            this.unreadCount = res.data.unread_notifications;
          }
        },
        (err) => {}
      );
  }
  tabClicked(e) {
    this.selectedTab = e.tab;
    // switch (e.tab){
    //   case 'inbox' : this.selectedTab='Billing';
    //   break;
    //   case 'archived' : this.selectedTab='Archived';
    //   break;
    //   case 'compose' : this.selectedTab='Messages';
    //   break;
    //   default : this.selectedTab='Billing';
    // }
}

}
